import { Link } from "react-router-dom";
import FilmPlayer from "../components/demo/FilmPlayer";
import { FILM_LENGTH, FILM_TITLE, SHOTS } from "@tour/shots.js";
import { clearFilmStore, filmHref, writeFilmStore } from "@tour/film.js";

function filmClock(seconds) {
  const safe = Math.max(0, Math.round(Number(seconds) || 0));
  return `${Math.floor(safe / 60)}:${String(safe % 60).padStart(2, "0")}`;
}

export default function SalesDemo() {
  function play(record) {
    const t0 = Date.now();
    clearFilmStore();
    writeFilmStore({ playing: true, t0, shot: 0, paused: false, record: Boolean(record) });
    window.location.assign(filmHref(SHOTS[0], 0, record, t0));
  }

  return (
    <div className="demo-curtain">
      <p className="home-kicker">A film of the live desk</p>
      <h1>{FILM_TITLE}</h1>
      <div className="btn-row">
        <button type="button" className="btn" onClick={() => play(true)}>
          Play for Magix
        </button>
        <button type="button" className="btn btn-ghost" onClick={() => play(false)}>
          Play with controls
        </button>
        <Link className="btn btn-ghost" to="/">
          Not now
        </Link>
      </div>
      <FilmPlayer />
      <p className="lead">
        The demo is the live walk ({filmClock(FILM_LENGTH)}): the site itself — black section cards,
        then the real pages with guided highlights. Use <strong>Play with controls</strong> to review
        and approve; <strong>Play for Magix</strong> hides the console until you hover (clean capture
        view). Space pauses. F toggles full frame. Escape leaves presentation.
      </p>
      <p className="lead film-player-note">
        An optional exported MP4 can appear below once <code>public/videos/sales-demo.mp4</code> exists
        (for USB or offline playback). That file is not required for the live demo.
      </p>
    </div>
  );
}
